import Payments from '@app/features/billing/Payments/Payments';

const PaymentsPage = () => {
  return <Payments />;
};

export default PaymentsPage;
